import { render } from "./FeaturesArea.vue?vue&type=template&id=30bb5728"
import script from "./FeaturesArea.vue?vue&type=script&lang=js"
export * from "./FeaturesArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__